import { RudderAnalytics } from '@rudderstack/analytics-js'
import { RUDDERSTACK_READY } from '../utils/events'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  const rudderAnalytics = new RudderAnalytics()
  // @ts-ignore
  rudderAnalytics.load(config.public.rudderStackWriteKey, config.public.rudderStackDataPlaneUrl, {
    configUrl: 'https://rd-api.healthpilot.com',
    pluginsSDKBaseURL: 'https://rd-sdk.healthpilot.com/v3/modern/plugins',
    destSDKBaseURL: 'https://rd-sdk.healthpilot.com/v3/modern/js-integrations',
    storage: {
      encryption: {
        version: 'v3'
      },
      migrate: true
    }
  })

  const rsInitialized = ref(false)
  const { $root } = useNuxtApp()

  rudderAnalytics.ready(() => {
    rsInitialized.value = true
    $root.emit(RUDDERSTACK_READY)
  })

  window.rudderanalytics = rudderAnalytics

  return {
    provide: {
      rs: rudderAnalytics,
      rsReady: rsInitialized
    }
  }
})
